import React, { useState, useCallback } from 'react';
import { Button, Modal } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * ResetButton Component
 * Displays a reset button with confirmation modal
 * Matches Figma design specifications
 *
 * @param {Object} props
 * @param {Function} props.onReset - Callback when reset is confirmed
 * @param {boolean} [props.disabled] - Whether the button is disabled
 */
const ResetButton = React.memo(({ onReset, disabled = false }) => {
  const { t } = useTranslation('riskCalculator');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleOk = useCallback(() => {
    setIsModalOpen(false);
    onReset();
  }, [onReset]);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <Button
        type="default"
        icon={<ReloadOutlined />}
        onClick={showModal}
        disabled={disabled}
        className="w-full sm:w-auto h-10 sm:h-[50px] px-3 sm:px-6 text-sm sm:text-base"
      >
        {t('reset_button')}
      </Button>

      <Modal
        title={<span className="text-base sm:text-lg">{t('reset_confirm_title')}</span>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={t('reset_confirm_ok')}
        cancelText={t('reset_confirm_cancel')}
        okButtonProps={{
          danger: true,
        }}
        width="90vw"
        style={{ maxWidth: 500 }}
      >
        <p className="text-sm sm:text-base">{t('reset_confirm_message')}</p>
      </Modal>
    </>
  );
});

ResetButton.displayName = 'ResetButton';

export default ResetButton;
